import { CSSProperties } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { Booster, Card, Contest, ContestParticipant } from 'models';

import BoosterCard from 'components/builder/BoosterCard';
import PlayerCard from 'components/builder/player-card/PlayerCard';

import { useAppSelector } from 'hooks/app';

import { selectSelectedBooster } from 'store/slices/contest';

interface SquadDeckProps {
  cards: Card[];
  participation: ContestParticipant;
  contest?: Contest;
  boosters?: Booster[];
}

const cardStyles: { [key: string]: CSSProperties } = {
  firstName: {
    textTransform: 'uppercase',
    color: 'inherit',
    fontSize: '10px',
  },
  lastName: {
    display: 'none',
  },
  image: {
    height: '136px',
  },
  info: {
    marginTop: '2px',
  },
};

const SquadDeck = ({ cards, participation, contest, boosters }: SquadDeckProps) => {
  const selectedBooster = useAppSelector(selectSelectedBooster);
  const mode = localStorage.getItem('sbc_mode');
  return (
    <>
      {/* <Box
        pos="relative"
        fontFamily="JetBrains Mono"
        fontSize="12px"
        fontWeight="500"
        textAlign="center"
        mt="16px"
        zIndex="10"
      >
        STARTERS
      </Box> */}

      <Flex
        alignItems="center"
        justifyContent="center"
        mt="28px"
        zIndex="10"
        sx={
          mode === 'iframe'
            ? {
              mb: mode === 'iframe' ? '-32px' : '0px',
              mt: mode === 'iframe' ? '-10px' : '0px',
              transform: 'scale(0.8)',
            }
            : {}
        }
      >
        {cards
          .filter((card) => card.status === 'start')
          .map((card, index) => (
            <PlayerCard
              card={card}
              contest={contest}
              width="108px"
              height="162px"
              zIndex={index === 1 ? 51 : 50}
              color="#9B9292"
              transform={
                index === 0 ? 'rotate(-8deg) translateY(9px)' : index === 2 ? 'rotate(8deg) translateY(9px)' : ''
              }
              styles={cardStyles}
              key={card.id}
              top={index === 1 ? '-8px' : '0'}
              mb="-6px"
            />
          ))}
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        mt="15px"
        gap="15px"
        pos="relative"
        zIndex="10"
        sx={
          mode === 'iframe'
            ? {
              mb: mode === 'iframe' ? '-16px' : '0px',
              transform: 'scale(0.8)',
            }
            : {}
        }
      >
        <Box
          fontFamily="JetBrains Mono"
          fontSize="12px"
          fontWeight="400"
          textAlign="center"
          pos="absolute"
          top="50%"
          left="50%"
          transform="translate(-165px, -50%)"
        >
          BENCH
        </Box>

        <Box
          fontFamily="JetBrains Mono"
          fontSize="12px"
          fontWeight="400"
          textAlign="center"
          pos="absolute"
          top="50%"
          right="50%"
          transform="translate(165px, -50%)"
        >
          BOOST
        </Box>

        <PlayerCard
          card={cards.find((card) => card.status === 'bench')!}
          height="162px"
          width="108px"
          transform="rotate(-4deg) translateY(0px)"
          bg="rgba(52, 52, 52, 1)"
          color="#D2C9C9"
          styles={cardStyles}
          contest={contest}
        />

        <BoosterCard
          height="162px"
          width="108px"
          transform="rotate(4deg) translateY(0px)"
          booster={participation.booster ?? selectedBooster ?? undefined}
          isDisabled={participation.status !== 'completion_pending' || boosters?.length === 0}
        />
      </Flex>
    </>
  );
};

export default SquadDeck;
